import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const SettingFullScreenButton = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    const element = document.documentElement;

    if (!document.fullscreenElement) {
      element.requestFullscreen().catch((err) => {
        console.error(
          `Error attempting to enable full-screen mode: ${err.message}`
        );
      });
      Cookies.set("isFullScreen", "true", { expires: 365 });
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      Cookies.remove("isFullScreen");
      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);

    const initialFullScreenState = Cookies.get("isFullScreen") === "true";
    setIsFullScreen(initialFullScreenState);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, []);

  return (
    <label className="switchDevice">
      <input
        type="checkbox"
        id="myCheck"
        checked={isFullScreen}
        onChange={toggleFullScreen}
      />
      <span className="switchSliderDevice round"></span>
    </label>
  );
};

export { SettingFullScreenButton };
// import React, { useState, useEffect } from "react";

// const SettingFullScreenButton = () => {
//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const toggleFullScreen = () => {
//     const element = document.documentElement;

//     if (!document.fullscreenElement) {
//       element.requestFullscreen().catch((err) => {
//         console.error(
//           `Error attempting to enable full-screen mode: ${err.message}`
//         );
//       });
//       localStorage.setItem("isFullScreen", "true");
//       setIsFullScreen(true);
//     } else {
//       document.exitFullscreen();
//       localStorage.removeItem("isFullScreen");
//       setIsFullScreen(false);
//     }
//   };

//   useEffect(() => {
//     const handleFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener("fullscreenchange", handleFullScreenChange);

//     const initialFullScreenState =
//       localStorage.getItem("isFullScreen") === "true";
//     setIsFullScreen(initialFullScreenState);

//     return () => {
//       document.removeEventListener("fullscreenchange", handleFullScreenChange);
//     };
//   }, []);

//   return (
//     <label className="switchDevice">
//       <input
//         type="checkbox"
//         id="myCheck"
//         checked={isFullScreen}
//         onChange={toggleFullScreen}
//       />
//       <span className="switchSliderDevice round"></span>
//     </label>
//   );
// };

// export { SettingFullScreenButton };
// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";

// const SettingFullScreenButton = () => {
//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const toggleFullScreen = () => {
//     const element = document.documentElement;

//     if (!document.fullscreenElement) {
//       element.requestFullscreen().catch((err) => {
//         console.error(
//           `Error attempting to enable full-screen mode: ${err.message}`
//         );
//       });
//       setIsFullScreen(true);
//       sessionStorage.setItem("isFullScreen", "true");
//       Cookies.set("isFullScreen", "true", { expires: 365 });
//     } else {
//       document.exitFullscreen();
//       Cookies.remove("isFullScreen");
//       setIsFullScreen(false);
//       sessionStorage.setItem("isFullScreen", "false");
//     }
//   };

//   useEffect(() => {
//     const handleFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener("fullscreenchange", handleFullScreenChange);

//     const initialFullScreenState =
//       sessionStorage.getItem("isFullScreen") === "true";
//     setIsFullScreen(initialFullScreenState);

//     return () => {
//       document.removeEventListener("fullscreenchange", handleFullScreenChange);
//     };
//   }, []);

//   return (
//     <label className="switchDevice">
//       <input
//         type="checkbox"
//         id="myCheck"
//         checked={isFullScreen}
//         onChange={toggleFullScreen}
//       />
//       <span className="switchSliderDevice round"></span>
//     </label>
//   );
// };

// export { SettingFullScreenButton };
